import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export interface Service {
  id: string;
  name: string;
  categoryType: string;
  primary: boolean;
  serviceType: string;
}

interface Props {
  serviceIds?: string[];
  enabled?: boolean;
}

export const useGetClaimServicesQuery = ({ serviceIds, enabled = true }: Props = {}) => {
  const { data, isLoading, isSuccess, isError } = useQuery(
    [API_URL.SERVICES, serviceIds],
    () =>
      api.get(API_URL.SERVICES, {
        params: serviceIds?.length ? { ids: serviceIds.join(',') } : undefined,
      }),
    {
      enabled,
    }
  );

  const services = useMemo(
    () =>
      data?.data?.map((service) => ({
        id: toString(service.id),
        name: service.name || '',
        categoryType: service.category_type,
        primary: service.primary,
        serviceType: service.service_type,
      })) || [],
    [data]
  );

  return {
    services: services as Service[],
    isLoading,
    isSuccess,
    isError,
  };
};
